import { useInfiniteQuery } from '@tanstack/react-query';

import { transportationApi } from '~endpoints/Transportation';
import { pointToPointTicketKeys } from '~queryKeys/transportation/pointToPointTicket';

type Keyword = Parameters<typeof transportationApi.v1.RailEurope.getPlaceList>[0];
type Page = Parameters<typeof transportationApi.v1.RailEurope.getPlaceList>[1];
type Size = Parameters<typeof transportationApi.v1.RailEurope.getPlaceList>[2];

export async function fetchPlaceList(keyword: Keyword, page?: Page, size?: Size) {
  return transportationApi.v1.RailEurope.getPlaceList(keyword, page, size);
}

const usePlaceList = ({ keyword, page, size }: { keyword: Keyword; page?: Page; size?: Size }) => {
  const query = useInfiniteQuery({
    queryKey: pointToPointTicketKeys.placeList(keyword, page, size),
    initialPageParam: 0,
    queryFn: ({ pageParam = 1 }) =>
      fetchPlaceList(keyword, pageParam, size).then((res) => res.data),
    getNextPageParam: (lastPage) => {
      if (!lastPage.hasNext) {
        return undefined;
      }

      return lastPage.pageNumber + 1;
    },
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 36 * 60 * 60 * 1000,
    enabled: !!keyword,
  });

  return { placeList: query.data, ...query };
};

export default usePlaceList;
